import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { PublicoAlvoApi } from 'app/domains/environment/publicos-alvo/apis/publico-alvo.api';
import { IPublicoAlvoListItem } from 'app/domains/environment/publicos-alvo/interfaces/publico-alvo-request.interface';
import { take } from 'rxjs/operators';

import { ToastService } from '../toast/services/toast.service';

interface IPublicoAlvoSelecionavel extends IPublicoAlvoListItem {
  checked: boolean;
}

@Component({
  selector: 'sgt-publico-alvo-select',
  templateUrl: './publico-alvo-select.component.html',
  styleUrls: ['./publico-alvo-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicoAlvoSelectComponent implements OnInit {
  @Input() idsJaSelecionados: number[] = [];

  @Output() concluir = new EventEmitter<IPublicoAlvoListItem[]>();
  @Output() fechar = new EventEmitter<void>();

  itens: IPublicoAlvoSelecionavel[] = [];
  busca = '';
  isLoading = false;

  constructor(
    private publicoAlvoApi: PublicoAlvoApi,
    private toastService: ToastService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.carregar();
  }

  private carregar(): void {
    this.isLoading = true;
    this.publicoAlvoApi
      .list()
      .pipe(take(1))
      .subscribe({
        next: (lista) => {
          this.itens = lista
            .map((p) => ({ ...p, checked: this.idsJaSelecionados.includes(p.id) }))
            .sort((a, b) => a.nome.localeCompare(b.nome));
          this.isLoading = false;
          this.cdr.markForCheck();
        },
        error: () => {
          this.toastService.error('Erro ao carregar públicos-alvo.');
          this.isLoading = false;
          this.cdr.markForCheck();
        },
      });
  }

  onBuscar(termo: string): void {
    this.busca = termo ?? '';
    this.cdr.markForCheck();
  }

  get itensFiltrados(): IPublicoAlvoSelecionavel[] {
    const termo = this.busca.trim().toLowerCase();
    if (!termo) {
      return this.itens;
    }
    return this.itens.filter((item) => item.nome.toLowerCase().includes(termo));
  }

  get totalSelecionados(): number {
    return this.itens.filter((item) => item.checked).length;
  }

  toggleItem(item: IPublicoAlvoSelecionavel): void {
    item.checked = !item.checked;
    this.cdr.markForCheck();
  }

  onConcluir(): void {
    const selecionados = this.itens
      .filter((item) => item.checked)
      .map(({ id, nome }) => ({ id, nome }));
    this.concluir.emit(selecionados);
  }

  onFechar(): void {
    this.fechar.emit();
  }

  trackById(_index: number, item: IPublicoAlvoSelecionavel): number {
    return item.id;
  }
}
